import {post} from './http'
const baseUrl = '/api/capwhale/center'
// 我的票券列表
export const getEventGettedTickets = v => post(`${baseUrl}/getEventGettedTickets`, v.data, v.success, v.error)
// 单个票券详情
export const getEventOrderTicket = v => post(`${baseUrl}/getEventOrderTicket`, v.data, v.success, v.error)
// 订单详情
export const getEventOrderDetail = v => post(`${baseUrl}/getEventOrderDetail`, v.data, v.success, v.error)
// 我的票券列表
export const getMyEventTickets = v => post(`${baseUrl}/getMyEventTickets`, v.data, v.success, v.error)